import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import { StyledImageWrapper } from './styles';

export const Image = ({
  forwardedRef,
  alt,
  title,
  src,
  onClick,
  className,
}) => {
  return (
    <StyledImageWrapper
      className={className}
      onClick={onClick}
      ref={forwardedRef}
    >
      <img alt={alt} src={src} title={title} />
    </StyledImageWrapper>
  );
};

export const ForwardedImage = forwardRef((props, ref) => (
  <Image forwardedRef={ref} {...props} />
));

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  onClick: PropTypes.func,
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
};

Image.defaultProps = {
  alt: '',
  className: '',
  forwardedRef: undefined,
  onClick: () => {},
  title: '',
};
